import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedRemoteSend = mutatorAction('updateAdvancedRemoteSend', function (remoteSend) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.remoteSend = remoteSend;
});
//# sourceMappingURL=updateAdvancedRemoteSend.js.map